// Simple DOM-based fly animation from reward modal image to a target element
// CSS dependency: .flying-item and @keyframes fly-to-target (already in luckySpin.css)

const TARGET_SELECTORS = {
  coins: '[data-reward-target="coins"]',
  tickets: '[data-reward-target="tickets"]',
  ton: '[data-reward-target="ton"]',
  // Предметы (части героев, сундуки, ключи) летят в иконку пункта меню Inventory
  inventory: '.menu-bar [data-reward-target="inventory"] .icon-wrapper',
  // Жизни мини-игр (v1.51.0) — туда же (Логово открывается из Inventory), но без бейджа «новое»
  lives: '.menu-bar [data-reward-target="inventory"] .icon-wrapper',
};

// Цель «подпрыгивает», когда в неё прилетает награда (CSS .reward-target-bump в index.css)
function bumpTarget(el, delay) {
  setTimeout(() => {
    el.classList.remove('reward-target-bump');
    void el.offsetWidth; // перезапуск анимации при повторном попадании
    el.classList.add('reward-target-bump');
    setTimeout(() => el.classList.remove('reward-target-bump'), 500);
  }, delay);
}

// Стайка из N иконок от точки клика к целям (как при клейме на экране Achievements).
// flights: [{ iconSrc, target }] — по одному полёту на тип награды.
// CSS: .flying-burst-item + @keyframes fly-burst-to-target (index.css — грузится всегда)
export function launchRewardBurst({ startRect, flights, count = 10, itemStagger = 70, typeStagger = 100 }) {
  try {
    if (!startRect || !Array.isArray(flights) || flights.length === 0) return;
    const startX = startRect.left + startRect.width / 2;
    const startY = startRect.top;

    flights.forEach(({ iconSrc, target }, ti) => {
      const selector = TARGET_SELECTORS[target] || TARGET_SELECTORS.coins;
      const targetEl = document.querySelector(selector);
      if (!targetEl) return;
      const end = targetEl.getBoundingClientRect();

      for (let i = 0; i < count; i++) {
        const img = document.createElement('img');
        img.src = iconSrc || '/coin_icon.png';
        img.className = 'flying-burst-item';
        img.style.left = `${startX - 14}px`;
        img.style.top = `${startY - 14}px`;
        img.style.animationDelay = `${i * itemStagger + ti * typeStagger}ms`;
        img.style.setProperty('--x', `${end.left + end.width / 2 - startX}px`);
        img.style.setProperty('--y', `${end.top + end.height / 2 - startY}px`);
        document.body.appendChild(img);
        setTimeout(() => img.remove(), 2400);
      }
      if (target === 'inventory') bumpTarget(targetEl, 1000 + (count - 1) * itemStagger + ti * typeStagger);
    });
  } catch (e) {
    console.error('launchRewardBurst error:', e);
  }
}

export function flyRewardToTarget({ iconSrc, target = 'coins', startRect }) {
  try {
    const start = startRect || document.querySelector('.modal-reward-image')?.getBoundingClientRect();
    if (!start) {
      console.warn('flyRewardToTarget: startRect not found');
      return;
    }

    const selector = TARGET_SELECTORS[target] || TARGET_SELECTORS.coins;
    const targetEl = document.querySelector(selector);
    
    if (!targetEl) {
      console.warn('flyRewardToTarget: target element not found', { target, selector });
      return;
    }
    
    const end = targetEl.getBoundingClientRect();
    console.log('✨ flyRewardToTarget: Animation started', { target, selector, start, end });

    const img = document.createElement('img');
    img.src = iconSrc || '/ticket_icon.png';
    img.className = 'flying-item';
    img.style.left = `${start.left}px`;
    img.style.top = `${start.top}px`;
    if (target === 'inventory') {
      // Иконка меню меньше летящей картинки — целимся центром в центр (60px — .flying-item)
      img.style.setProperty('--x', `${end.left + end.width / 2 - 30 - start.left}px`);
      img.style.setProperty('--y', `${end.top + end.height / 2 - 30 - start.top}px`);
      img.classList.add('flying-item--shrink');
      bumpTarget(targetEl, 1400);
    } else {
      img.style.setProperty('--x', `${end.left - start.left}px`);
      img.style.setProperty('--y', `${end.top - start.top}px`);
    }
    document.body.appendChild(img);

    setTimeout(() => {
      img.remove();
    }, 1600);
  } catch (e) {
    console.error('flyRewardToTarget error:', e);
  }
}
